import { render, staticRenderFns } from "./reset-via-email.vue?vue&type=template&id=fbdb476c&"
import script from "./reset-via-email.vue?vue&type=script&lang=js&"
export * from "./reset-via-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports